import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import BrandMarquee from "@/components/Marquee";
import FeaturedOffer from "@/components/FeaturedOffer";
import About from "@/components/About";
import Services from "@/components/Services";
import Institute from "@/components/Institute";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import Assistant from "@/components/Assistant";

export default function Home() {
  const { dir, setOverrides } = useLang();
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/content").then((r) => {
      setContent(r.data);
      if (r.data?.texts) setOverrides(r.data.texts);
    }).catch(() => setContent(null));
  }, [setOverrides]);

  const contact = content?.contact;
  const images = content?.images || {};

  return (
    <div dir={dir} className="bg-ivory min-h-screen">
      <Header contact={contact} />
      <main>
        <Hero contact={contact} images={images} />
        <BrandMarquee />
        <FeaturedOffer offer={content?.offer} contact={contact} />
        <About images={images} />
        <Services content={content} />
        <Institute images={images} />
        <Contact contact={contact} />
      </main>
      <Footer contact={contact} />
      <FloatingWhatsApp contact={contact} />
      <Assistant enabled={content?.assistant?.enabled !== false} contact={contact} />
    </div>
  );
}
